import { useTranslation } from 'react-i18next';
import { AlertIcon, CheckCircleIcon, CloseIcon } from '@utils/icons';
import type { IToast } from './useToasts';
import styles from './Toasts.module.css';

interface IToastsProps {
  toasts: IToast[];
  onDismiss: (id: number) => void;
}

/** Bottom-center toast stack. */
export function Toasts({ toasts, onDismiss }: IToastsProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${toast.kind === 'error' ? styles.error : styles.success}`}
        >
          <span className={styles.icon}>
            {toast.kind === 'success' ? <CheckCircleIcon size={18} /> : <AlertIcon size={18} />}
          </span>
          <div className={styles.body}>
            <b>{toast.title}</b>
            {toast.sub ? <div className={styles.sub}>{toast.sub}</div> : null}
          </div>
          <button
            type="button"
            className={styles.close}
            onClick={() => onDismiss(toast.id)}
            aria-label={t('common.dismiss')}
          >
            <CloseIcon size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
